// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_qd-8";
export var editMode = "_qd-3";
export var headerRow = "_qd-a";
export var headerTitle = "_qd-b";
export var product = "_qd-1";
export var productDetails = "_qd-5";
export var productDivider = "_qd-7";
export var productImage = "_qd-2";
export var productInfo = "_qd-4";
export var productTitle = "_qd-6";
export var strikethrough = "_qd-9";
export var upsellProductsCard = "_qd-0";